import * as React from 'react';

export const TrowelSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="51.022" height="51.063" viewBox="0 0 51.022 51.063"><g transform="translate(0.84 19.824) rotate(-45)"><rect width="3.356" height="13.424" transform="translate(11.746 25.17)" fill="#fff" stroke="#041156" strokeWidth="1.8"/><path d="M13.424,0,26.848,30.2H0Z" transform="translate(0 0)" fill="#ffd803" stroke="#041156" strokeLinecap="round" strokeLinejoin="bevel" strokeWidth="1.8"/><path d="M0,11.6a3.22,3.22,0,0,0,3.22,3.22h.215a3.22,3.22,0,0,0,3.22-3.22V0H0Z" transform="translate(10.068 37.631)" fill="#fff" stroke="#041156" strokeWidth="1.8"/></g></svg>
  );
};
